import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IKitComponent, IKitComponentInput } from "@/interfaces/kit.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class KitService {
  private baseUrl = "api/v1/kit";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IKitComponent>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const kits = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return kits;
  }

  async filter(
    filter: IFilter<IKitComponent>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IKitComponent>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: IKitComponentInput): Promise<void> {
    await httpRequest.post(this.baseUrl, formData);
  }

  async getById(kitId: number): Promise<IKitComponent> {
    const kit = await httpRequest.get(`${this.baseUrl}/${kitId}`);

    return kit;
  }

  async update(formData: IKitComponentInput, kitId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${kitId}`, formData);
  }

  async delete(kitId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${kitId}`);
  }
}

const kitService = new KitService();
export default kitService;
